import React from "react";
import { mockProperties } from "../../constants/mockProperties";
import { members } from "./components";
import { ProfileSummary } from "../../constants/branchData";
import DynamicSlider from "./components/DynamicSlider";
import ContactMandate from "./components/ContactMandate";
import { TeamCardWhatsapp } from "./components/TeamCard";
import SimilarProperties from "./components/SimilarProperties";
import { BranchSummaryCard } from "./Branches";
import PropertyUtilities from "../../constants/utilitiesIcons";
import { LocationIcon } from "./PropertyPage1";
import { utilities } from "./PropertyPage1";
import { PriceCard } from "./PropertyPage1";
import { ParentCard } from "./PropertyPage1";
import Accordion from "./components/Accordion";
import Example from "./components/Map";
import { PropertyInfo } from "./RentPage1";
import { ShowMoreText } from "./About1";
import { mockDesc } from "../design2/Sale2";
export function camelCaseToWords(camelCaseStr: string): string {
  return camelCaseStr
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}

const PropertyPage1 = () => {
  return (
    <section className="py-10 w-full overflow-clip">
      <div className="wrapper">
        <div className="grid-container relative">
          <div className="item flex flex-col gap-10">
            <div className="carousel w-auto">
              <DynamicSlider
                url="hello"
                slides={[...mockProperties["forRent"][0].images]}
              />
            </div>
            <div className="carousel my-4">
              <div className="first flex items-center justify-between">
                <h3 className="font-semibold">
                  {mockProperties.forRent[0].title}
                </h3>
                <span className="text-label-main">
                  Property ID: {mockProperties.forRent[0].id}
                </span>
              </div>
              <div className="first flex items-center justify-between">
                <h5 className="text-label flex gap-1">
                  <LocationIcon />
                  {mockProperties.forShortlet[0].address}
                </h5>
                <span className="text-themeColor capitalize">
                  {mockProperties.forRent[0].category}
                </span>
              </div>
            </div>
            <ParentCard header="Property Brief">
              <ShowMoreText text={mockDesc} />
            </ParentCard>

            <ParentCard header="Rules">
              <PropertyUtilities list="rules" selectedItems={mockRules} />
            </ParentCard>
            <BranchSummaryCard variant {...newOccupants} />
            <BranchSummaryCard variant {...renewalOccupants} />
            <ParentCard header="Facilities">
              <PropertyUtilities selectedItems={utilities} />
            </ParentCard>
            {/* <BranchSummaryCard variant {...propertyData} /> */}
            {/* <BranchSummaryCard variant {...propertyDataCharge} /> */}
            <PropertyInfo
              details={bookingDetails}
              title="Booking Information"
            />
            <Accordion
              data={{
                title: "Terms & Conditions",
                questions: [
                  {
                    question: "Refund Policy",
                    answer: "You can request a refund within 7 days.",
                  },
                  {
                    question: "Property Facility",
                    answer: "Facilities include WiFi, Pool, and Gym.",
                  },
                  {
                    question: "Other Rules",
                    answer: "No smoking inside the premises.",
                  },
                ],
              }}
            />
            {/* <ParentCard header="Document">
              <p>C of O. Record Copy Survey, Agreement</p>
            </ParentCard> */}
            <ParentCard header="Location">
              <Example coordinates={[6.4913408, 3.391488]} />
            </ParentCard>
          </div>
          <div id="child" className=" w-full flex flex-col gap-14">
            <PriceCard {...mockProperties.forShortlet[0]} />
            <div className="card mt-24">
              <TeamCardWhatsapp {...members[0]} />
            </div>
            <ContactMandate email={members[0].email} />
          </div>
        </div>
        <SimilarProperties
          arr={[...mockProperties["forSale"], ...mockProperties["forSale"]]}
        />
      </div>
    </section>
  );
};
export default PropertyPage1;

export const mockRules = [
  "No Smoking",
  "Children Allowed",
  "No Pets",
  "No Parties",
  "No Alcohol",
];

const newOccupants: ProfileSummary = {
  title: "New Occupants",
  values: {
    "Price Per Night": "₦3,300,300",
    "Refundable Caution Fee": "₦3,300,300",
    "First Payment": "₦3,300,300",
    "Total Payment": "₦3,300,300",
  },
};

const renewalOccupants: ProfileSummary = {
  title: "Renewal Occupants",
  values: {
    "Cost Per Night": "₦3,300,300",
    "Subsequential Payment": "₦3,300,300",
  },
};

const bookingDetails = [
  { key: "Property Name", value: "Obolongo Estate" },
  { key: "Booking Type", value: "Per Day" },
  { key: "Guest Capacity", value: "5" },
  { key: "Guest Allowed", value: "7" },
  { key: "Maximum Booking Duration", value: "1 Week" },
  {
    pair: [
      { key: "Check In", value: "2:30 pm" },
      { key: "Check In", value: "3:30 pm" },
    ],
  },
];
